import axiosInstance from "@/helpers/axiosInstance";
import { flattenQuery, searchParamsQuery } from "@/utils/flatternQuery";
import { AxiosProgressEvent } from "axios";

interface FetcherOptions {
  url: string;
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  params?: Record<string, any>;
  data?: any;
  signal?: AbortSignal;
  headers?: Record<string, string>;
  onUploadProgress?: (progress: number) => void;
}

export async function fetcher<T = any>(options: FetcherOptions): Promise<T> {
  const { url, method = "GET", params, data, signal, headers = {}, onUploadProgress } = options;

  const flattenedParams = params ? flattenQuery(params) : {};
  const searchParams = searchParamsQuery(flattenedParams);

  const config = {
    method,
    url: searchParams.toString() ? `${url}?${searchParams.toString()}` : url,
    data,
    signal,
    headers: {
      ...headers,
    },
    onUploadProgress: onUploadProgress
      ? (event: AxiosProgressEvent) => {
          if (event.total) {
            const percent = Math.round((event.loaded * 100) / event.total);
            onUploadProgress(percent);
          }
        }
      : undefined,
  };

  const response = await axiosInstance.request<T>(config);
  return response.data;
}
